import SolutionDetailsModal from './SolutionDetailsModal';

export default SolutionDetailsModal;
